import { render, staticRenderFns } from "./ZDMReportsTabCustom.vue?vue&type=template&id=0db31e22&scoped=true&"
import script from "./ZDMReportsTabCustom.vue?vue&type=script&lang=js&"
export * from "./ZDMReportsTabCustom.vue?vue&type=script&lang=js&"
import style0 from "./ZDMReportsTabCustom.vue?vue&type=style&index=0&id=0db31e22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db31e22",
  null
  
)

export default component.exports